var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFontS({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.024 17.848c2.353 0 3.76-1.408 3.76-3.104 0-1.52-.88-2.304-2.112-2.832l-1.424-.592c-.864-.352-1.663-.656-1.663-1.472 0-.768.655-1.232 1.647-1.232.897 0 1.6.336 2.273.896l.943-1.184A4.62 4.62 0 0012.232 7c-2.047 0-3.52 1.28-3.52 2.944 0 1.536 1.089 2.352 2.113 2.784l1.44.624c.944.4 1.615.672 1.615 1.536 0 .816-.64 1.344-1.824 1.344-.96 0-1.967-.48-2.72-1.184L8.25 16.312a5.42 5.42 0 003.775 1.536z"
  })));
}

export default SvgFontS;